<form [formGroup]="form" class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit event class</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Class name'"
          [placeholder]="'Class name'"
          [type]="'text'"
          [value]="v('class_name')"
          (valueChange)="set('class_name', $event)"
          [invalid]="classNameInvalid"
        ></app-input-component>
      </div>

      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="classTypes"
          [displayKey]="'class_name'"
          [multiple]="false"
          [value]="v('parent_class_id')"
          (valueChange)="set('parent_class_id', $event || null)"
        ></app-selectorini>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'Description'"
          [placeholder]="'Description'"
          [type]="'text'"
          [value]="v('class_description')"
          (valueChange)="set('class_description', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Start date/time'"
          [placeholder]="'YYYY-MM-DDTHH:mm'"
          [type]="'datetime-local'"
          [value]="v('start_date_time')"
          (valueChange)="set('start_date_time', $event)"
          [invalid]="startInvalid"
        ></app-input-component>
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Max registrations'"
          [placeholder]="'Max registrations'"
          [type]="'number'"
          [value]="v('max_num_registrations')"
          (valueChange)="set('max_num_registrations', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="horseRegistries"
          [displayKey]="'registry_name'"
          [multiple]="false"
          [value]="getSelectedHorseRegistry()"
          (valueChange)="set('req_horse_registration_id', $event?.registry_id || null)"
        ></app-selectorini>
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Max participant age'"
          [placeholder]="'Max age'"
          [type]="'number'"
          [value]="v('max_participant_age')"
          (valueChange)="set('max_participant_age', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Min horse age'"
          [placeholder]="'Min age'"
          [type]="'number'"
          [value]="v('min_horse_age')"
          (valueChange)="set('min_horse_age', $event)"
        ></app-input-component>
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Seconds per participant'"
          [placeholder]="'Seconds'"
          [type]="'number'"
          [value]="v('time_per_participant_seconds')"
          (valueChange)="set('time_per_participant_seconds', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Price'"
          [placeholder]="'Price'"
          [type]="'number'"
          [value]="v('price')"
          (valueChange)="set('price', $event)"
        ></app-input-component>
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Currency'"
          [placeholder]="'Currency'"
          [type]="'text'"
          [value]="v('price_currency')"
          (valueChange)="set('price_currency', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-12">
        <app-selectorini
          [options]="membershipPlans"
          [displayKey]="'name'"
          [multiple]="true"
          [value]="v('req_membership_plans')"
          (valueChange)="set('req_membership_plans', $event || [])"
        ></app-selectorini>
      </div>
    </div>

    <!-- Sponsors Section -->
    <div class="row g-4 spacing-30">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="mb-0">Sponsors</h4>
          <app-button
            [label]="'Create New Sponsor'"
            [variant]="'primary'"
            [iconClass]="'fa fa-plus-circle'"
            (clicked)="openCreateSponsorModal()"
          ></app-button>
        </div>

        @if (loadingSponsors) {
          <div class="text-center py-3">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Loading sponsors...
          </div>
        } @else {
          @if (selectedSponsors.length > 0) {
            <div class="row g-3">
              @for (sponsor of selectedSponsors; track sponsor.sponsor_id) {
                <div class="col-lg-6 col-12">
                  <div class="card h-100">
                    <div class="card-body">
                      <div class="d-flex gap-3">
                        <div class="flex-shrink-0">
                          @if (sponsor.logo_url) {
                            <img [src]="sponsor.logo_url" alt="{{ sponsor.sponsor_name }}" class="sponsor-logo" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px;">
                          } @else {
                            <div class="sponsor-placeholder d-flex align-items-center justify-content-center" style="width: 80px; height: 80px; background-color: #f0f0f0; border-radius: 8px;">
                              <i class="fa fa-image text-muted" style="font-size: 2rem;"></i>
                            </div>
                          }
                        </div>
                        <div class="flex-grow-1">
                          <div class="d-flex justify-content-between align-items-start mb-2">
                            <h5 class="mb-0">{{ sponsor.sponsor_name }}</h5>
                            <button
                              type="button"
                              class="btn-close"
                              (click)="removeSponsor(sponsor)"
                              aria-label="Remove sponsor"
                            ></button>
                          </div>
                          <p class="text-muted small mb-0">{{ sponsor.sponsor_description || 'No description provided' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="text-center py-4 border rounded bg-light">
              <i class="fa fa-handshake-o text-muted mb-2" style="font-size: 2.5rem;"></i>
              <p class="text-muted mb-0">No sponsors added yet. Click "Create New Sponsor" to add one.</p>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <app-button
      [label]="saving ? 'Saving…' : 'Save'"
      [variant]="'primary'"
      [disabled]="saving || form.invalid || !eventClass?.event_class_id"
      (clicked)="save()"
    ></app-button>
  </div>
</form>
